/** @format */
import {
    blackColor,
    boxShadow,
    dangerColor,
    drawerMiniWidth,
    drawerWidth,
    grayColor,
    hexToRgb,
    infoColor,
    primaryBoxShadow,
    primaryColor,
    roseColor,
    successColor,
    transition,
    warningColor,
    whiteColor,
} from '../../../../jss/material-dashboard-pro-react';
import OPL_STYLE from '../../OplStyle';
import COLORS from '../../colors';

const OplSidebarStyle = (theme: any): any => ({
    drawerPaperRTL: {
        [theme.breakpoints.up('md')]: {
            left: 'auto !important',
            right: '0 !important',
        },
        [theme.breakpoints.down('sm')]: {
            left: '0  !important',
            right: 'auto !important',
        },
    },
    drawerPaper: {
        border: 'none',
        position: 'fixed',
        top: '0',
        bottom: '0',
        left: '0',
        zIndex: '1032',
        overflowX: 'hidden',
        transitionProperty: 'top, bottom, width',
        transitionDuration: '.2s, .2s, .35s',
        transitionTimingFunction: 'linear, linear, ease',
        overflowY: 'scroll',
        // overflow: 'auto',
        // borderRight: `1px solid ${OPL_STYLE.BORDER}`,
        width: drawerWidth,
        [theme.breakpoints.up('md')]: {
            width: drawerWidth,
            position: 'fixed',
            height: '100%',
        },
        [theme.breakpoints.down('sm')]: {
            width: drawerWidth,
            ...boxShadow,
            position: 'fixed',
            display: 'block',
            top: '0',
            height: '100vh',
            right: '0',
            left: 'auto',
            zIndex: '1032',
            visibility: 'visible',
            overflowY: 'visible',
            borderTop: 'none',
            textAlign: 'left',
            paddingRight: '0px',
            paddingLeft: '0',
            transform: `translate3d(${drawerWidth}px, 0, 0)`,
            ...transition,
        },
        '&:before,&:after': {
            position: 'absolute',
            zIndex: '3',
            width: '100%',
            height: '100%',
            content: '""',
            display: 'block',
            top: '0',
        },
    },
    blackBackground: {
        color: OPL_STYLE.FONT.PRIMARY,
        '&:after': {
            background: OPL_STYLE.BACKGROUND.PRIMARY,
        },
    },
    whiteAfter: {
        '&:after': {
            backgroundColor: 'hsla(0,0%,71%,.3) !important',
        },
    },
    drawerPaperMini: {
        width: 105 + 'px!important',
        overflowX: 'hidden'
    },
    logo: {
        padding: '25px 15px',
        height: '100px',
        margin: '0',
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'baseline',
        position: 'relative',
        zIndex: '4',
        '&:after': {
            content: '""',
            position: 'absolute',
            bottom: '0',
            height: '1px',
            right: '15px',
            width: 'calc(100% - 30px)',
            backgroundColor: OPL_STYLE.BORDER,
        },
    },
    logoMini: {
        transition: 'all 300ms linear',
        opacity: 1,
        textAlign: 'center',
        width: '50px',
        maxHeight: '50px',
        color: 'inherit',
    },
    logoMiniRTL: {
        float: 'right',
        marginRight: '30px',
        marginLeft: '26px',
    },
    logoNormal: {
        transition: 'all 300ms linear',
        display: 'flex',
        opacity: '1',
        transform: 'translate3d(0px, 0, 0)',
        textTransform: 'uppercase',
        padding: '5px 0px',
        fontSize: '18px',
        whiteSpace: 'nowrap',
        fontWeight: '400',
        lineHeight: '30px',
        overflow: 'hidden',
        '&,&:hover,&:focus': {
            color: 'inherit',
        },
    },
    logoNormalRTL: {
        textAlign: 'right',
    },
    logoNormalSidebarMini: {
        opacity: '0',
        transform: 'translate3d(-25px, 0, 0)',
    },
    logoNormalSidebarMiniRTL: {
        transform: 'translate3d(25px, 0, 0)',
    },
    img: {
        width: '50px',
        height: '50px',
        border: '0',
    },
    background: {
        position: 'absolute',
        zIndex: '1',
        height: '100%',
        width: '100%',
        display: 'block',
        top: '0',
        left: '0',
        backgroundSize: 'cover',
        backgroundPosition: 'center center',
        transition: 'all 300ms linear',
    },
    list: {
        marginTop: '15px',
        paddingLeft: '0',
        paddingTop: '0',
        paddingBottom: '0',
        marginBottom: '0',
        listStyle: 'none',
        color: 'inherit',
        '&:before,&:after': {
            display: 'table',
            content: '" "',
        },
        '&:after': {
            clear: 'both',
        },
    },
    item: {
        color: 'inherit',
        position: 'relative',
        display: 'block',
        textDecoration: 'none',
        margin: '0',
        padding: '0',
    },
    userItem: {
        '&:last-child': {
            paddingBottom: '0px',
        },
    },
    itemLink: {
        color: COLORS.MAIN.LIGHT,
        paddingLeft: '10px',
        paddingRight: '10px',
        transition: 'all 300ms linear',
        margin: '10px 20px 0',
        borderRadius: '3px',
        display: 'flex',
        justifyContent: 'center',
        padding: '10px',
        backgroundColor: 'transparent',
        width: 'auto',
        '&:hover': {
            color: 'inherit',
            outline: 'none',
            backgroundColor: COLORS.DARK_FUNCTION.FUNCTION_1,
            boxShadow: 'none',
        },
        '&:focus': {
            color: 'inherit'
        },
    },
    itemIconWrapper: {
        width: '28px',
        height: 'auto',
        marginRight: '15px',
    },
    itemIcon: {
        color: OPL_STYLE.FONT.PRIMARY,
        fill: OPL_STYLE.FONT.PRIMARY,
        width: '28px',
        height: 'auto',
        float: 'left',
        position: 'inherit',
        top: '3px',
        marginRight: '15px',
        textAlign: 'center',
        verticalAlign: 'middle',
    },
    itemIconRTL: {
        float: 'right',
        marginLeft: '15px',
        marginRight: '1px',
    },
    itemText: {
        color: 'inherit',
        margin: '0',
        lineHeight: '30px',
        fontSize: '14px',
        transform: 'translate3d(0px, 0, 0)',
        opacity: '1',
        transition: 'transform 300ms ease 0s, opacity 300ms ease 0s',
        position: 'relative',
        display: 'block',
        height: 'auto',
        whiteSpace: 'nowrap',
    },
    userItemText: {
        lineHeight: '22px',
    },
    itemTextRTL: {
        marginRight: '45px',
        textAlign: 'right',
    },
    itemTextMini: {
        transform: 'translate3d(-25px, 0, 0)',
        opacity: '0',
    },
    itemTextMiniRTL: {
        transform: 'translate3d(25px, 0, 0) !important',
    },
    collapseList: {
        marginTop: '0',
    },
    collapseItem: {
        position: 'relative',
        display: 'block',
        textDecoration: 'none',
        margin: '10px 0 0 0',
        padding: '0',
    },
    collapseActive: {
        outline: 'none',
        boxShadow: 'none',
    },
    collapseItemLink: {
        transition: 'all 300ms linear',
        margin: '0 15px',
        borderRadius: '3px',
        position: 'relative',
        display: 'block',
        padding: '10px',
        backgroundColor: 'transparent',
        width: 'auto',
        '&:hover': {
            outline: 'none',
            backgroundColor: 'rgba(' + hexToRgb(grayColor[17]) + ', 0.2)',
            boxShadow: 'none',
        },
        '&,&:hover,&:focus': {
            color: 'inherit',
        },
    },
    collapseItemMini: {
        color: 'inherit',
        textTransform: 'uppercase',
        width: '50px',
        marginRight: '15px',
        textAlign: 'center',
        letterSpacing: '1px',
        position: 'relative',
        float: 'left',
        display: 'inherit',
        transition: 'transform 300ms ease 0s, opacity 300ms ease 0s',
        fontSize: '14px',
    },
    collapseItemMiniRTL: {
        float: 'right',
        marginLeft: '30px',
        marginRight: '1px',
    },
    collapseItemText: {
        color: 'inherit',
        margin: '0',
        position: 'relative',
        transform: 'translateX(0px)',
        opacity: '1',
        whiteSpace: 'nowrap',
        display: 'block',
        transition: 'transform 300ms ease 0s, opacity 300ms ease 0s',
        fontSize: '14px',
    },
    collapseItemTextRTL: {
        textAlign: 'right',
    },
    collapseItemTextMiniRTL: {
        transform: 'translate3d(25px, 0, 0) !important',
    },
    collapseItemTextMini: {
        transform: 'translate3d(-25px, 0, 0)',
        opacity: '0',
    },
    caret: {
        marginTop: '13px',
        position: 'absolute',
        right: '18px',
        transition: 'all 150ms ease-in',
        display: 'inline-block',
        width: '0',
        height: '0',
        marginLeft: '2px',
        verticalAlign: 'middle',
        borderTop: '4px solid',
        borderRight: '4px solid transparent',
        borderLeft: '4px solid transparent',
    },
    userCaret: {
        marginTop: '10px',
    },
    caretRTL: {
        left: '11px',
        right: 'auto',
    },
    caretActive: {
        transform: 'rotate(180deg)',
    },
    orange: {
        '&,&:hover,&:focus': {
            color: COLORS.MAIN.PRIMARY,
        },
        '& *': {
            color: `${COLORS.MAIN.PRIMARY} !important`,
            fill: `${COLORS.MAIN.PRIMARY} !important`
        }
    },
    sidebarWrapper: {
        position: 'relative',
        height: 'calc(100vh - 75px)',
        overflowX: 'hidden',
        width: '260px',
        zIndex: '4',
        transitionProperty: 'top, bottom, width',
        transitionDuration: '.2s, .2s, .35s',
        transitionTimingFunction: 'linear, linear, ease',
        color: 'inherit',
        paddingBottom: '30px',
    },
    sidebarWrapperWithPerfectScrollbar: {
        overflow: 'hidden !important',
    },
    user: {
        paddingBottom: '20px',
        margin: '20px auto 0',
        position: 'relative',
        '&:after': {
            content: '""',
            position: 'absolute',
            bottom: '0',
            right: '15px',
            height: '1px',
            width: 'calc(100% - 30px)',
            backgroundColor: OPL_STYLE.BORDER,
        },
    },
    photo: {
        transition: 'all 300ms linear',
        width: '34px',
        height: '34px',
        overflow: 'hidden',
        float: 'left',
        zIndex: '5',
        marginRight: '11px',
        borderRadius: '50%',
        marginLeft: '23px',
        ...boxShadow,
    },
    photoRTL: {
        float: 'right',
        marginLeft: '12px',
        marginRight: '24px',
    },
    avatarImg: {
        width: '100%',
        verticalAlign: 'middle',
        border: '0',
    },
    userCollapseButton: {
        margin: '0',
        padding: '6px 15px',
        '&:hover': {
            background: 'none',
        },
    },
    userCollapseLinks: {
        marginTop: '-4px',
        '&:hover,&:focus': {
            color: COLORS.MAIN.LIGHT,
        },
    },
    sidebarMinimizeButton: {
        position: 'absolute',
        bottom: 10,
        left: 10
    },
    sidebarArrow: {
        width: 15,
        fill: COLORS.MAIN.LIGHT,
        position: 'absolute',
        right: 5,
        top: 8,
    },
    sidebarArrowActive: {
        fill: COLORS.MAIN.PRIMARY
    },
    logoTitle: {
        fontSize: '1.6rem',
        fontWeight: 900,
        marginLeft: 15
    },
    sidebarMenuButton: {
        zIndex: 99999,
        position: 'absolute',
        left: 30,
        bottom: 10,
        overflowX: 'hidden',
        '& *': {
            backgroundColor: COLORS.MAIN.PRIMARY
        }
    }
});

export default OplSidebarStyle;
